export default "__VITE_ASSET__D9IyQhNi__"